import { useInfiniteQuery } from '@tanstack/react-query';

import { fetchClaimItems } from '../data-provider/claim-items';
import type { ClaimItemsResponse, GetClaimItemsRequestParams } from '../data-provider/claim-items/api';

export interface UseGetClaimItemsParams {
  claimKey: number | undefined;
  pageSize?: number;
  sortColumn?: string;
  sortDirection?: 'ASC' | 'DESC';
}

type ClaimItemsPage = ClaimItemsResponse;

export const useGetClaimItems = ({
  claimKey,
  pageSize = 10,
  sortColumn = 'itemSeq',
  sortDirection = 'DESC',
}: UseGetClaimItemsParams) => {
  return useInfiniteQuery<ClaimItemsPage>({
    enabled: Boolean(claimKey),
    getNextPageParam: (lastPage) => lastPage.nextPage,
    initialPageParam: 1,
    queryFn: ({ pageParam = 1 }) => {
      const params: GetClaimItemsRequestParams = {
        claimKey: Number(claimKey),
        pageIndex: Number(pageParam),
        pageSize,
        sortColumn,
        sortDirection,
      };
      return fetchClaimItems(params);
    },
    queryKey: ['claims-loss-and-damage-items', claimKey, sortColumn, sortDirection],
    select: (data) => {
      const items = data.pages.flatMap((page) => page?.data ?? []);
      const lastPage = data.pages[data.pages.length - 1];
      const pageIndex = data.pages.length;

      return {
        ...data,
        items,
        pageIndex,
        totalProductClaimAmount: Number(lastPage?.totalProductClaimAmount ?? 0),
        totalRows: Number(lastPage?.totalRows ?? 0),
      };
    },
  });
};
